(function () {
  function init() {
    var header = document.querySelector('#header-component');
    var wrapper = document.querySelector('.page-wrapper');
    if (!header || !wrapper) return;

    initSlideProgress();

    // The sticky slide-down reveal is homepage-only. The header only gets the
    // transparent attribute there (enable_transparent_header_home), and it's
    // the only page with the hero slideshow; everywhere else the header just
    // stays in its normal place at the top of the page.
    var hero = document.querySelector('slideshow-component');
    if (!header.hasAttribute('transparent') || !hero) return;

    var pinned = false;
    var ticking = false;
    // A gap between the pin and unpin points (instead of one shared value)
    // stops minor scroll jitter right at the boundary — common with trackpad
    // momentum scrolling — from rapidly toggling pinned on/off, which would
    // restart the slide animation from scratch each time and could look
    // exactly like an instant snap even though the code runs correctly.
    var PIN_AT = 200;
    var UNPIN_AT = 180;

    // Horizon scrolls .page-wrapper on desktop but the document itself on
    // narrower/mobile viewports, so .page-wrapper's own scrollTop can stay
    // at 0 there. Read whichever one is actually moving.
    function getScrollTop() {
      var docTop = (document.scrollingElement || document.documentElement).scrollTop;
      return Math.max(wrapper.scrollTop, docTop);
    }

    // No space is reserved below the hero while pinned: the transparent
    // header is absolutely positioned (out of flow) before pinning and fixed
    // (also out of flow) after, so nothing in the page moves when it pins.
    // Adding padding here would itself shove the content down by a header
    // height at the exact moment the slide starts.

    // The slide duration lives in CSS (--dur-header-slide). Read it so the
    // transitionend safety timeout stays in step with the stylesheet.
    function cssDuration(name, fallback) {
      var raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
      var value = parseFloat(raw);
      if (isNaN(value)) return fallback;
      return raw.indexOf('ms') === -1 ? value * 1000 : value;
    }
    function slideDuration() {
      return cssDuration('--dur-header-slide', 700);
    }
    function returnDuration() {
      return cssDuration('--dur-header-return', 420);
    }

    var closeTimer = null;
    var openToken = 0;

    function finishClose() {
      if (closeTimer !== null) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      header.classList.remove('pc-sticky-closing', 'pc-sticky-fixed');
      startReturn();
    }

    // Dropping the fixed positioning puts the header straight back in its
    // in-flow transparent spot over the hero, which on its own is a one-frame
    // pop-in of the white logo and icons. pc-sticky-returning runs a short
    // opacity fade (see precise-coffee.css) so it eases in instead. A timeout
    // backs up animationend, and re-pinning cancels the fade outright.
    var returnTimer = null;

    function endReturn() {
      if (returnTimer !== null) {
        clearTimeout(returnTimer);
        returnTimer = null;
      }
      header.classList.remove('pc-sticky-returning');
    }

    function startReturn() {
      endReturn();
      // Force a style flush so re-adding the class restarts the animation
      // even if the previous fade was interrupted a moment ago.
      void header.offsetWidth;
      header.classList.add('pc-sticky-returning');
      returnTimer = setTimeout(endReturn, returnDuration() + 100);
    }

    header.addEventListener('animationend', function (event) {
      if (event.target !== header || event.animationName !== 'pc-header-return') return;
      endReturn();
    });

    // Once the slide-up has finished, drop the fixed positioning so the
    // header returns to its normal in-flow spot. Ignore transitionend events
    // bubbling up from children (link colours, the hover fill) and any
    // transform transition that isn't the close.
    header.addEventListener('transitionend', function (event) {
      if (event.target !== header || event.propertyName !== 'transform') return;
      if (header.classList.contains('pc-sticky-closing')) finishClose();
    });

    // The slide is a CSS transition on transform (see precise-coffee.css), so
    // it runs on the compositor thread rather than being stepped from JS on
    // the main thread, which drops frames while the page is still scrolling.
    // Open: become fixed at translateY(-100%) first, wait a frame so the
    // browser has painted that start position, then add the active class to
    // transition to translateY(0). Close: swap active for closing,
    // which keeps the transition declared while the transform returns to
    // -100%; a timeout backs up transitionend in case it never fires.
    function slideTo(open) {
      if (closeTimer !== null) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (open) {
        endReturn();
        header.classList.remove('pc-sticky-closing');
        header.classList.add('pc-sticky-fixed');
        // Let the browser render one frame in the fixed/off-screen state
        // before starting the transition, so it begins on a clean frame
        // boundary rather than mid-way through a busy scroll frame. The
        // double rAF is the reliable way to wait for that frame to paint.
        var token = ++openToken;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (token !== openToken || !pinned) return;
            header.classList.add('pc-sticky-active');
          });
        });
      } else {
        header.classList.remove('pc-sticky-active');
        header.classList.add('pc-sticky-closing');
        closeTimer = setTimeout(finishClose, slideDuration() + 100);
      }
    }

    // Pins (and starts the slide-down) once the page is scrolled past PIN_AT.
    function update() {
      ticking = false;
      var scrollTop = getScrollTop();
      var shouldPin = pinned ? scrollTop > UNPIN_AT : scrollTop >= PIN_AT;
      if (shouldPin === pinned) return;
      pinned = shouldPin;
      slideTo(pinned);
    }

    // Collapses any number of scroll events per frame (including the
    // duplicate firing from listening on both wrapper and window) down to
    // at most one update per animation frame.
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    wrapper.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  // Replaces the separate pause/play button with progress fills on the
  // pagination bars themselves (one per slide). The active bar fills over
  // the autoplay duration from the slideshow's own "autoplay" attribute
  // (seconds); bars for slides already shown stay fully filled.
  //
  // The bar is the single source of truth for timing: the slide advances
  // when its bar finishes filling (animationend), instead of running on
  // slideshow.js's separate setInterval clock. That clock restarts from
  // zero whenever the pointer leaves the slideshow and never restarts after
  // a manual arrow click, so a bar running independently drifted out of
  // step with when the slide actually changed. slideshow.js's interval is
  // therefore switched off here and its play() neutralised to only clear
  // the paused state; the bar pauses on hover to match the suspend-on-hover
  // it would otherwise do.
  //
  // Skipped under prefers-reduced-motion: the global reduced-motion rule
  // collapses the fill to ~0ms, which would advance slides continuously.
  function initSlideProgress() {
    var hero = document.querySelector('slideshow-component');
    if (!hero) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var dots = hero.querySelectorAll('.slideshow-controls__dots button');
    if (!dots.length) return;

    var seconds = parseInt(hero.getAttribute('autoplay'), 10);
    if (!seconds || typeof hero.next !== 'function') return;
    document.documentElement.style.setProperty('--slide-progress-duration', seconds * 1000 + 'ms');

    if (typeof hero.suspend === 'function') hero.suspend();
    hero.play = function () {
      this.paused = false;
    };

    function onFillEnd(event) {
      if (event.animationName !== 'pc-slide-fill' || event.pseudoElement !== '::before') return;
      if (hero.paused) return;
      hero.next();
    }

    function sync() {
      var activeIndex = -1;
      for (var i = 0; i < dots.length; i++) {
        if (dots[i].getAttribute('aria-selected') === 'true') activeIndex = i;
      }
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.remove('pc-slide-done', 'pc-slide-current');
        if (j < activeIndex) dots[j].classList.add('pc-slide-done');
        else if (j === activeIndex) dots[j].classList.add('pc-slide-current');
      }
    }

    for (var k = 0; k < dots.length; k++) {
      new MutationObserver(sync).observe(dots[k], { attributes: true, attributeFilter: ['aria-selected'] });
      dots[k].addEventListener('animationend', onFillEnd);
    }
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
